import React, { useEffect, useState } from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest, profileRequest } from "../authConfig";
//import { getInfoUsers } from "../services/ApiGetUserInfo";
import { callMsGraphGroup } from "../graphGroup";
import LoadingSpinner from "../shared/LoadingSpinner";

interface UserInfo {
  // Define your user info type here
  // Example: name: string;
}

interface Props {
  children: React.ReactNode;
}

export const PageLayout: React.FC<Props> = (props) => {
  const { instance, accounts } = useMsal();
  const [isLoading, setIsLoading] = useState<boolean>(true);
  //const [userInfo, setUserInfo] = useState<UserInfo | null>(null);
  const [accessTokenFetched, setAccessTokenFetched] = useState<boolean>(false);

  const request = { ...loginRequest, account: accounts[0] };
  const profileRequestOptions = { ...profileRequest, account: accounts[0] };

  useEffect(() => {
    const fetchData = async () => {
      try {
        if (!accessTokenFetched) {
          // Check if Access Token has been fetched before
          const response = await instance.acquireTokenSilent(request);
          sessionSet("AccessToken", response.accessToken, 1);
          setAccessTokenFetched(true); // Set to true to prevent future calls
        }

        const storedAccessToken = sessionStorage.getItem("AccessToken");
        if (storedAccessToken) {
          //const infoResponse = await getInfoUsers(storedAccessToken);
          setIsLoading(false);
         // setUserInfo(infoResponse);
          fetchMsGraphGroup();
        }
      } catch (error) {
        handleError(error);
      }
    };

    if (!accessTokenFetched) {
      fetchData();
    }
  }, [accessTokenFetched]);

  const fetchMsGraphGroup = async () => {
    try {
      if (
        !sessionStorage.getItem("usergroup") ||
        sessionStorage.getItem("usergroup") === "undefined"
      ) {
        const response = await instance.acquireTokenSilent(
          profileRequestOptions
        );
        sessionSet("GraphAccessToken", response.accessToken, 60);
        const group = await callMsGraphGroup(response.accessToken);
        sessionStorage.setItem("usergroup", JSON.stringify(group));
      }
    } catch (error) {
      handleError(error);
    }
  };

  const handleError = (error: any) => {
    console.log(error);
    console.log(error.message);

    if (
      error.message === "AxiosError: Network Error" ||
      error.message === "AxiosError: Request failed with status code 500"
    ) {
      setIsLoading(false);
      window.location.reload();
    }

    if (error.message === "AxiosError: Request failed with status code 400") {
      setIsLoading(false);
     // setUserInfo(error.message);
    }
  };

  const sessionSet = (key: string, value: any, expirationInMin: number = 10) => {
    const expirationDate = new Date(
      new Date().getTime() + 60000 * expirationInMin
    );
    const newValue = {
      value: value,
      expirationDate: expirationDate.toISOString(),
    };
    sessionStorage.setItem(key, JSON.stringify(newValue));
  };

  return (
    <>
      {isLoading ? (
        <div className="layout-loading">
          <div className="lds-ring">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      ) : (
        props.children
      )}
    </>
  );
};
